import { useCallback, useEffect, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import { getImageUrl } from '../../../actions/images';
import { TYPES, useShowModal } from '../../../actions/modal';
import { setCurrentUser } from '../../../actions/tasks';
import { getCurrentTaskSelector } from '../../../selectors/screen';
import { useAnchorEl } from '../../hooks/useAnchorEl';

export const useAppBarMenu = (translate) => {
    const dispatch = useDispatch();
    const [anchorEl, handleOpenMenu, handleClose] = useAnchorEl();
    const showModal = useShowModal();

    const { crewId, users, userId, userName, userNameEng, userPreview, taskUsers } = useSelector((state) => {
        const { users: userState } = state;
        const currentTask = getCurrentTaskSelector(state);

        const user = get(state, 'screen.currentUser');
        const users = userState.list || {};
        const crewId = user && user.id && get(users, `[${user.id}].crewId`);

        return {
            crewId,
            users,
            userId: user ? user.id : '',
            userName: user ? user.name : '',
            //TODO Для совместимости. После перевода всех пользователей на версию 4.3.6 убрать проверку
            // userNameEng: user ? user.nameEng : '',
            userNameEng: user ? (user.nameEng ? user.nameEng : user.name) : '',
            userPreview: user ? user.preview : '',
            taskUsers: get(currentTask, 'users', []),
        };
    }, shallowEqual);

    const user = useMemo(
        () => ({
            crewId,
            id: userId,
            preview: userPreview,
            name: userName,
            nameEng: userNameEng,
        }),
        [crewId, userName, userNameEng, userId, userPreview]
    );

    const userList = useMemo(() => taskUsers.map((item) => users[item]), [taskUsers]);

    useEffect(() => {
        if (!user.preview && user.crewId) {
            dispatch(getImageUrl(`img_${user.crewId}`)).then((url) => {
                dispatch(
                    setCurrentUser({
                        id: user.id,
                        preview: url,
                        name: user.name,
                        nameEng: user.nameEng,
                    })
                );
            });
        }
    }, [user]);

    const handleSettingsClick = useCallback(() => {
        showModal(TYPES.SETTING, {});
        handleClose();
    }, []);

    const handleChangeUser = useCallback(() => {
        showModal(TYPES.CHANGE_USER, {});
        handleClose();
    }, []);

    const handleWhatsNew = useCallback(() => {
        showModal(TYPES.WHATS_NEW, {
            isAccepted: true,
            title: translate('whatsNew.whatsNew'),
        });
        handleClose();
    });

    return {
        anchorEl,
        user,
        userList,
        handleChangeUser,
        handleClose,
        handleOpenMenu,
        handleSettingsClick,
        handleWhatsNew,
    };
};
